import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C7.451 2 3.75 5.7285 3.75 10.3125C3.75 15.9475 10.206 21.5 12 21.5C13.794 21.5 20.25 15.9475 20.25 10.3125C20.25 5.7285 16.549 2 12 2ZM12.002 7C13.794 7 15.252 8.45891 15.252 10.252C15.252 12.044 13.794 13.5 12.002 13.5C10.21 13.5 8.752 12.044 8.752 10.252C8.75195 8.45891 10.21 7 12.002 7Z",
		fill: "currentColor"
	})
});
export default SvgLocationFill;
